<template>
  <div>
    <b-table
      responsive
      selectable
      hoover
      :striped="true"
      :select-mode="selectMode"
      :items="items"
      :fields="columns"
      class="mb-0"
      @row-selected="onRowSelected"
    >
      <template #head(id)="data">
        <span class="text-info">{{ data.label.toUpperCase() }}</span>
      </template>
      <template #cell(status)="data">
        <b-badge
          pill
          :variant="variant(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>
      <template #cell(account.status)="data">
        <b-badge
          pill
          :variant="variant(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>
      <template #cell(approved)="data">
        <b-badge
          pill
          :variant="variant(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>
      <template #cell(account.approved)="data">
        <b-badge
          pill
          :variant="variant(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>
      <template #cell(granted)="data">
        <b-badge
          pill
          :variant="data.value ? 'success' : 'danger'"
        >
          {{ data.value }}
        </b-badge>
      </template>
      <template #cell(isConverted)="data">
        <b-badge
          pill
          :variant="data.value ? 'success' : 'danger'"
        >
          {{ data.value }}
        </b-badge>
      </template>
      <template #cell(created)="data">
        {{ formatDate(data.value) }}
      </template>
      <template #cell(account.created)="data">
        {{ formatDate(data.value) }}
      </template>
      <template #cell(amount)="data">
        {{ parseFloat(data.value).toFixed(2) }}
      </template>
      <template #cell(deletedAt)="data">
        {{ formatDate(data.value) }}
      </template>
      <template #cell(purchased)="data">
        {{ formatDate(data.value) }}
      </template>
    </b-table>
    <div :style="{ display: showButtons }">
      <span> {{ startIndex }} – {{ endIndex }} of many</span>
      <b-button-toolbar
        key-nav
        aria-label="Toolbar with button groups"
        class="demo-inline-spacing"
      >
        <!-- group 3 -->
        <b-button-group>
          <b-button
            v-b-tooltip.hover.top="'Start Page'"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="btn-icon"
            @click="startPage"
          >
            <feather-icon icon="ChevronsLeftIcon" />
          </b-button>
          <b-button
            v-b-tooltip.hover.top="'Load next page'"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            class="btn-icon"
            variant="outline-primary"
            @click="nextPage"
          >
            <feather-icon icon="ChevronRightIcon" />
          </b-button>
        </b-button-group>
      </b-button-toolbar>
    </div>
  </div>
</template>

<script>
import {
  BBadge, BButton, BButtonGroup, BButtonToolbar, BTable, VBTooltip,
} from 'bootstrap-vue'
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'DataTable',
  components: {
    BTable,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    title: {
      type: String,
      default: 'Table',
    },
    api: {
      type: String,
      default: '/',
    },
    columns: {
      type: Array,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    idUrl: {
      type: String,
      default: null,
    },
    onRowSelectedCallback: {
      type: Function,
      argumentCount: 1,
      default: null,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    // badge colours for this table's own status values, e.g. { NORMAL: 'success' }; others use variant()
    statusVariants: {
      type: Object,
      default: () => ({}),
    },
    fields: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      items: [],
      dataApi: this.api,
      previousCursor: undefined,
      nextCursor: undefined,
      showLoading: 'block',
      showButtons: 'none',
      startIndex: 1,
      endIndex: 0,
      selectMode: 'single',
    }
  },
  mounted() {
    this.nextCursor = undefined
    this.previousCursor = undefined
    this.loadData(this.nextCursor)
  },
  methods: {
    formatDate(unixtimestanp) {
      const a = new Date(unixtimestanp)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const year = a.getFullYear()
      const month = months[a.getMonth()]
      const date = a.getDate()
      const hour = a.getHours()
      const min = a.getMinutes()
      const sec = a.getSeconds()
      return `${date} ${month} ${year} ${hour}:${min}:${sec}`
    },
    variant(status) {
      if (this.statusVariants[status]) {
        return this.statusVariants[status]
      }
      if (status === 'ENABLED' || status === 'COMPLETED') {
        return 'success'
      } if (status === 'PENDING' || status === 'IN_PROGRESS') {
        return 'primary'
      }
      return 'danger'
    },
    resolvePath(obj, path) {
      return path.split('.').reduce((prev, curr) => (prev ? prev[curr] : undefined), obj)
    },
    onRowSelected(row) {
      if (this.id !== null && row.length > 0) {
        this.$router.push(this.idUrl + this.resolvePath(row[0], this.id))
      }

      if (this.onRowSelectedCallback !== null && row.length > 0) {
        this.onRowSelectedCallback(row)
      }
    },
    nextPage() {
      this.loadData(this.nextCursor)
    },
    startPage() {
      this.startIndex = 1
      this.endIndex = 0
      this.loadData()
    },
    loadData(cursor) {
      this.showLoading = 'block'
      this.showButtons = 'none'
      let url = `${this.$readerURL}${this.dataApi}`

      if (cursor !== undefined) {
        url = `${url}?cursor=${cursor}`
      }
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.get(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.items = response.data.data
          this.previousCursor = this.cursor
          this.nextCursor = response.data.cursor
          this.showLoading = 'none'
          this.showButtons = 'block'
          this.startIndex = this.endIndex + 1
          this.endIndex += this.items.length
          return response
        }).catch(error => {
          this.loader('none')
          this.showLoading = 'none'
          this.showButtons = 'block'
          return error
        })
      })
    },
  },
}
</script>
